export const tableParamettersModel = {
  currentPage: 0,
  rowsPerPage: 7,
  rowsPerPageOptions: [7],
  count: 0,
}